import React, { useState, useContext, useEffect } from 'react'
import { usePrevious } from 'react-use'
import useCallbackOnTrue from 'lib/hooks/useCallbackOnTrue'

import { Field } from 'formik'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import TextArea from 'components/Forms/FormElements/TextArea'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'

import './event-form-comment-module.pcss'

const fieldName = 'comment'

const EventFormCommentModule = ({ label }) => {
    const { values, errors, extendedActions } = useContext(ExtendedFormikContext)

    const commentValue = values[fieldName]

    const [open, setOpen] = useState(commentValue && commentValue.length > 0)
    const prevOpen = usePrevious(open)

    useEffect(() => {
        // check if opened after mount
        if (prevOpen === false && open) {
            extendedActions.focusField(fieldName)
        }
    }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

    useCallbackOnTrue(errors[fieldName], () => setOpen(true))

    return (
        <EventFormModule className="event-form-comment-module">
            <CompactFormRow
                iconName={['far', 'comment']}
                iconFlip="horizontal"
                label={label}
                onClick={() => !open && setOpen(!open)}
                expandable={!open}
                trackName={fieldName}
            />
            {!!open && (
                <Field
                    type="text"
                    name={fieldName}
                    label=""
                    component={TextArea}
                    rows={2}
                    minRows={2}
                    maxRows={15}
                    maxLength={5000}
                    autoSize
                />
            )}
        </EventFormModule>
    )
}

export default EventFormCommentModule
